// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f-VV","colBig":"styles_colBig__291pL","colSmall":"styles_colSmall__O5KOa","shopifyNameWrapper":"styles_shopifyNameWrapper__2Ear0"};